import * as Yup from 'yup';

import { required } from 'features/new-auth/validationSchema';
import { isValidCPF } from 'shared/utils/validation';
import { onlyNumbers } from 'shared/utils/formatters';

export const validationForm = Yup.object({
  cpf: Yup.string()
    .required(required)
    .test({
      name: 'cpf',
      message: 'CPF inválido',
      test(value) {
        return isValidCPF(onlyNumbers(value ?? ''));
      },
    }),
  crm: Yup.string(),
  zip_code: Yup.string().when('existing_clinic_address', {
    is: false,
    then: Yup.string().required(required),
    otherwise: Yup.string().nullable(),
  }),
  existing_clinic_address: Yup.boolean(),
});
